@if (!auth.initialized()) {
  <main class="auth-loading" aria-live="polite">Loading workspace…</main>
} @else if (auth.user()) {
  <main class="app-shell" [class.navigation-is-collapsed]="navigationCollapsed()">
    <app-side-navigation
      [collapsed]="navigationCollapsed()"
      [threads]="chatPersistence.threads()"
      (collapsedChange)="setNavigationCollapsed($event)"
      (newChat)="startNewChat()"
      (signOut)="signOut()"
    />
    <section class="app-content">
      <router-outlet />
    </section>
  </main>
} @else {
  <router-outlet />
}
